module.exports = __webpack_public_path__ + "img/3.9078b6b1.jpg";